import { OrderService } from 'src/services/order.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const ORDER_NEW_CARE_SUCCESS = 'ORDER:NEW_CARE_SUCCESS'
export const ORDER_LIST_SUCCESS = 'ORDER:FIND_ALL_SUCCESS'
export const ORDER_LIST_FAILD = 'ORDER:FIND_ALL_FAILD'
export const ORDER_COUNT_ASSIGN_SUCCESS = 'ORDER:COUNT_ASSIGN_SUCCESS'
export const ORDER_COUNT_ASSIGN_FAILD = 'ORDER:COUNT_ASSIGN_FAILD'

export const ORDER_CREATE_SUCCESS = 'ORDER:CREATE_SUCCESS'
export const ORDER_CREATE_FAILD = 'ORDER:CREATE_FAILD'

export const ORDER_IMPORT_SUCCESS = 'ORDER:IMPORT_SUCCESS'
export const ORDER_SAVE_SUCCESS = 'ORDER:SAVE_SUCCESS'
export const ORDER_SAVE_FAILD = 'ORDER:SAVE_SUCCESS'

export const ORDER_DEL_SUCCESS = 'ORDER:DEL_SUCCESS'
export const ORDER_DEL_FAILD = 'ORDER:DEL_FAILD'

export const ORDER_ONE_SUCCESS = 'ORDER:FIND_ONE_SUCCESS'
export const ORDER_ONE_FAILD = 'ORDER:FIND_ONE_FAILD'

export const ORDER_HISTORY_LIST_SUCCESS = 'ORDER:HISTORY_FIND_ALL_SUCCESS'
export const ORDER_HISTORY_LIST_FAILD = 'ORDER:HISTORY_FIND_ALL_FAILD'

export const ORDER_UPDATE_FILTER = 'ORDER:ORDER_UPDATE_FILTER'

export const ORDER_LIST_EXPORT_SUCCESS = 'ORDER:FIND_ALL_EXPORT_SUCCESS'
export const ORDER_LIST_EXPORT_FAILD = 'ORDER:FIND_ALL_EXPORT_FAILD'

export const ORDER_ORDER_SUCCESS = 'ORDER:ORDER_SUCCESS'
export const ORDER_ORDER_FAILD = 'ORDER:ORDER_FAILD'

export const ORDER_UPDATE_HOMEPAGE_FILTER = 'ORDER:ORDER_UPDATE_HOMEPAGE_FILTER'

export const ORDER_HOMEPAGE_LIST_SUCCESS = 'ORDER:FIND_HOMEPAGE_LIST_SUCCESS'
export const ORDER_HOMEPAGE_LIST_FAILD = 'ORDER:FIND_HOMEPAGE_LIST_FAILD'

export const ORDER_HOMEPAGE_ONE_SUCCESS = 'ORDER:FIND_HOMEPAGE_ONE_SUCCESS'
export const ORDER_HOMEPAGE_ONE_FAILD = 'ORDER:FIND_HOMEPAGE_ONE_FAILD'

export const ORDER_LIMIT_UPDATE_HOMEPAGE_FILTER = 'ORDER:ORDER_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const ORDER_LIMIT_HOMEPAGE_LIST_SUCCESS = 'ORDER:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const ORDER_LIMIT_HOMEPAGE_LIST_FAILD = 'ORDER:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const ORDER_LIMIT_HOMEPAGE_ONE_SUCCESS = 'ORDER:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const ORDER_LIMIT_HOMEPAGE_ONE_FAILD = 'ORDER:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const OrderAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,
    sendOrder,
}

function updateHomepageFilter(payload) {
    return { type: ORDER_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { order } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageOrderFilter } = order;
        const homepageOrderPage = homepageOrderFilter.homepageOrderPage;
        const homepageOrderLimit = homepageOrderFilter.homepageOrderLimit;

        return new Promise((resolve, reject) => {
            OrderService.homepageList(homepageOrderFilter).then((rs) => {
                if (!!homepageOrderFilter && homepageOrderFilter.homepageOrderPage === 0) {
                    dispatch(success({
                        homepageOrderItems: rs.data.values,
                        homepageOrderTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = order.homepageOrderItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageOrderLimit * homepageOrderPage; i < homepageOrderLimit * homepageOrderPage + homepageOrderLimit; i++) {
                        if (typeof rsDataValues[i - homepageOrderLimit * homepageOrderPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageOrderLimit * homepageOrderPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageOrderItems: uniqueItems,
                        homepageOrderTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: ORDER_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: ORDER_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        OrderService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: ORDER_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { order } = getState();
        // dispatch(AppAction.appLoading(true));

        const { homepageOrderLimitFilter } = order;
        const homepageOrderLimitPage = homepageOrderLimitFilter.homepageOrderLimitPage;
        const homepageOrderLimitLimit = homepageOrderLimitFilter.homepageOrderLimitLimit;

        return new Promise((resolve, reject) => {
            OrderService.homepageLimitList(homepageOrderLimitFilter).then((rs) => {
                if (!!homepageOrderLimitFilter && homepageOrderLimitFilter.homepageOrderLimitPage === 0) {
                    dispatch(success({
                        homepageOrderLimitItems: rs.data.values,
                        homepageOrderLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = order.homepageOrderLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageOrderLimitLimit * homepageOrderLimitPage; i < homepageOrderLimitLimit * homepageOrderLimitPage + homepageOrderLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageOrderLimitLimit * homepageOrderLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageOrderLimitLimit * homepageOrderLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageOrderLimitItems: uniqueItems,
                        homepageOrderLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: ORDER_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: ORDER_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        OrderService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: ORDER_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      OrderService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: ORDER_LIST_SUCCESS, data } }
    function failure(error) { return { type: ORDER_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        OrderService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: ORDER_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { order } = getState()
        dispatch(AppAction.appLoading(true));
        OrderService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...order.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_LIST_SUCCESS, data } }
    function failure(error) { return { type: ORDER_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            OrderService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: ORDER_SAVE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            OrderService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { order } = getState();

            const { filter } = order;

            // Perform your asynchronous operation (e.g., API call)
            OrderService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: ORDER_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: ORDER_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { order } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = order;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            OrderService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = order.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: ORDER_LIST_SUCCESS, data } }
    function failure(error) { return { type: ORDER_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: ORDER_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            OrderService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(OrderAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: ORDER_SAVE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_SAVE_FAILD, error } }
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        OrderService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(OrderAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng số điện thoại!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_CREATE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        OrderService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(OrderAction.list())
            if (typeof rs.msg !== 'undefined' && rs.msg) {
                alert(rs.msg)
            }
        }).catch((error) => {
            dispatch(failure(error));
            alert("Lỗi không xác định!")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_CREATE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        OrderService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(OrderAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_DEL_SUCCESS, data } }
    function failure(error) { return { type: ORDER_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        OrderService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_ONE_SUCCESS, data } }
    function failure(error) { return { type: ORDER_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        OrderService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(OrderAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { order } = getState()
        dispatch(AppAction.appLoading(true));
        OrderService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...order.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: ORDER_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        OrderService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: ORDER_ORDER_SUCCESS, data } }
    function failure(error) { return { type: ORDER_ORDER_FAILD, error } }
}